import React from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter, Routes, Route,useLocation } from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';

import ImpersonationBanner from './components/ImpersonationBanner'; 

import Home from './pages/Home';
import Doctors from './pages/doctors';

import BookingPage from './pages/BookingPage';
import HospitalPage from './pages/hospitalPage';
import LabPage from './pages/LabPage';
import SurgeriesPage from './pages/SurgeriesPage';
import HealthBlogPage from './pages/HealthBlogPage';
import ReviewsPage from './pages/ReviewsPage';
import PaymentPage from './pages/PaymentPage';
import MyAppointments from './pages/MyAppointments';
import ProfilePage from './pages/ProfilePage';
import SingleBlogPage from './pages/SingleBlogPage';
import DoctorDashboard from './pages/DoctorDashboard';
import SampleCollectionPage from './pages/SampleCollectionPage';
import MedicalRecords from './pages/MedicalRecords';
import DiscountCard from './pages/DiscountCard';
import HospitalRegisterModal from './components/HospitalRegisterModal';
import HospitalDashboard from './pages/HospitalDashboard';
import AdminLogin from './pages/AdminLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/Responsive.css'
import './styles/main.css';
import './styles/hospital.css';
import './styles/lab.css';
import './styles/booking.css';
import './styles/surgeries.css';
import './styles/healthblog.css';
import './styles/reviews.css';
import './styles/payment.css';

import './styles/Doctors.css';
import './styles/Header.css';
import './styles/Footer.css';

import Chatbot from './components/ChatBot';
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <>
    <ImpersonationBanner />
      {/* 1. Website Header (Hidden on Admin) */}
      {!isAdminRoute && <Header />}
      {!isAdminRoute && <HospitalRegisterModal />}
      
      {/* 2. Main Content 
          - Admin: Renders directly (Full Screen, No Margins)
          - Website: Renders inside <main> (Centered, Standard Margins)
      */}
      {isAdminRoute ? (
         children 
      ) : (
         <main>{children}</main>
      )}

      {/* 3. Website Footer (Hidden on Admin) */}
      {!isAdminRoute && <Footer />}
    </>
  );
};

function App() {
  // Wake up server on load
  useEffect(() => {
    const wakeUpServer = async () => {
      try {
        await axios.get(process.env.REACT_APP_API_BASE_URL);
        console.log("Server Woken Up!");
      } catch (error) { console.log("Ping sent to server"); }
    };
    wakeUpServer();
  }, []);

  return (
    <BrowserRouter>
      {/* WRAP EVERYTHING INSIDE LAYOUT */}
      <Layout>
        <Routes>
          {/* Public Website Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/doctors" element={<Doctors />} />
          <Route path="/specialty/:specialty" element={<Doctors />} />
          <Route path="/book/:doctorId" element={<BookingPage />} />
          <Route path="/my-appointments" element={<MyAppointments />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/hospitals/:locationName" element={<HospitalPage />} />
          <Route path="/labs/:locationName" element={<LabPage />} />
          <Route path="/surgeries" element={<SurgeriesPage />} />
          <Route path="/health" element={<HealthBlogPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/payment" element={<PaymentPage />} />
          <Route path="/health-blog/:id" element={<SingleBlogPage />} />
          <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
          <Route path="/sample-collection" element={<SampleCollectionPage />} />
          <Route path="/medical-records" element={<MedicalRecords />} />
          <Route path="/discount-card" element={<DiscountCard />} />
          <Route path="/hospital-dashboard" element={<HospitalDashboard />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<SuperAdminDashboard />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;